import { DemoToggleButtonGroupControl } from '@/components/Demo';

import FlexDemo from './FlexDemo';
import Item from './Item';
import Output from './Output';

function LayoutMode() {
  return (
    <FlexDemo
      initialValues={{
        display: 'block',
        '--gap': '0px',
      }}
      customGrid={{
        gridTemplateColumns: '1fr',
      }}
      controls={[
        <DemoToggleButtonGroupControl
          inline
          key="display"
          id="display"
          label="display"
          options={['block', 'flex']}
        />,
      ]}
    >
      {(state) => (
        <Output state={state}>
          <Item>Hello</Item>
          <Item>to</Item>
          <Item>the</Item>
          <Item>world</Item>
        </Output>
      )}
    </FlexDemo>
  );
}

export default LayoutMode;
